// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DespesasCategorias_DeleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/despesas_categorias/delete
 *
 * Action endpoint — emits an empty success envelope (no dados payload).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type DespesasCategorias_DeleteResponseDados = null;

export type DespesasCategorias_DeleteResponse = ApiResponse<DespesasCategorias_DeleteResponseDados>;

registerResponseContract('DespesasCategorias_DeleteResponse', {})
